import type { Api } from "../../../data/api";
import { normalizeWhatsapp, type WhatsappOverview } from "./whatsapp-model";

/** WhatsApp-Hinweise je Ereignis (0159): Stand lesen (Team), Wahl ändern (nur Admins, prüft die Datenbank). */
export async function loadWhatsapp(api: Pick<Api, "read">, orgId: string): Promise<WhatsappOverview> {
  return normalizeWhatsapp(await api.read<WhatsappOverview>("org_whatsapp_overview", { p_org: orgId }));
}

/** Nummer trennen (nur Admins): Konto und Zugang weg, zurück in den Probelauf (0167). */
export async function disconnectWhatsapp(api: Pick<Api, "rpc">, orgId: string): Promise<void> {
  await api.rpc("org_whatsapp_disconnect", { p_org: orgId });
}

/** enabled = null setzt das Ereignis auf die Vorgabe zurück. */
export async function setWhatsappEvent(api: Pick<Api, "rpc">, orgId: string, key: string, enabled: boolean | null): Promise<void> {
  await api.rpc("org_whatsapp_event_set", { p_org: orgId, p_key: key, p_enabled: enabled });
}
